/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Table, Form, Button, Grid, Segment,
  Popup, Icon, Image, Modal, Header,
  Divider
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { read, write } from "xlsx";
import { pingGraphAction } from "../actions/changeActiveItemActions";
import { Charts, ChartContainer, ChartRow, EventChart, Resizable } from "react-timeseries-charts";
import { TimeSeries, TimeRangeEvent, TimeRange } from "pondjs";
import Strings from "./utilities/StringSelector";
import Constants from "./utilities/Constants";
import Utils from "./utilities/Utils";

// Regex to match agains the form input to know if the user typed an IP or a device name
const ipRegex = new RegExp("^[0-2][0-9.]*$");
const nameRegex = new RegExp("^[A-Za-z][A-Za-z-0-9]*");
const macRegex = new RegExp("^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$");

const UtilsInstance = new Utils();

class LiveList extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      column: null,

      sortDirection: "ascending",
      originalDevices: [],
      devices: [],
      pingLimit: "",
      networkAvailability: 0,

      isColumnClicked: false,

      showModal: false,
      clickedDevice: "",
      clickedMac: "",
      askDeleteText: Strings.ASK_DELETE_OR_LOG_1
    };
  }

  addAditionalInfoToDevices = (devices) => {
    let devicesCopy = JSON.parse(JSON.stringify(devices));

    for (let i = 0; i < devicesCopy.length; i++) {
      if (devicesCopy[i].status === Constants.FAULT) {
        devicesCopy[i].severity = 0;
      }
      else if (devicesCopy[i].status === Constants.OK) {
        devicesCopy[i].severity = 3;
      }
      else if (devicesCopy[i].status === Constants.ONLINE) {
        devicesCopy[i].severity = 2;
      }
      else if (devicesCopy[i].status === Constants.OFFLINE) {
        devicesCopy[i].severity = 1;
      }
    }
    return devicesCopy;
  }

  // Sorts the table when the user clicks on one of the columns
  handleSort = clickedColumn => () => {

    this.setState({
      isColumnClicked: true
    });

    if (clickedColumn === "ip" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num1 - num2;
        }),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by ip descending
    else if (clickedColumn === "ip" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort((a, b) => {
          const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
          return num2 - num1;
        }),
        sortDirection: "ascending",
      });
    }
    // The user wants to order devices by mac ascending
    else if (clickedColumn === "mac" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "mac",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order devices by mac descending
    else if (clickedColumn === "mac" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "mac",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by protocol ascending
    else if (clickedColumn === "protocol" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "protocol",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by protocol descending
    else if (clickedColumn === "protocol" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "protocol",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by config_method ascending
    else if (clickedColumn === "config_method" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "config_method",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by config_method descending
    else if (clickedColumn === "config_method" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "config_method",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by lostPingsPercentage ascending
    else if (clickedColumn === "lostPingsPercentage" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "lostPingsPercentage",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by lostPingsPercentage descending
    else if (clickedColumn === "lostPingsPercentage" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "lostPingsPercentage",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by availability ascending
    else if (clickedColumn === "percentageAvailable" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "percentageAvailable",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by availability descending
    else if (clickedColumn === "percentageAvailable" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "percentageAvailable",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by severity ascending
    else if (clickedColumn === "severity" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "severity",
            false,
            parseInt)
        ),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by severity descending
    else if (clickedColumn === "severity" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "severity",
            true,
            parseInt)
        ),
        sortDirection: "ascending",
      });
    }
  }

  handleIPSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];
    for (let i = 0; i < len; i++) {
      if (this.state.originalDevices[i].ip === this.state.formInput) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  handleMacAddressSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      // Uppercases both strings before comparison to allow search flexibility
      if (this.state.originalDevices[i].mac != null && this.state.formInput != null) {
        if (this.state.originalDevices[i].mac.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  handleProtocolSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      // Uppercases both strings before comparison to allow search flexibility
      if (this.state.originalDevices[i].protocol != null && this.state.formInput != null) {
        if (this.state.originalDevices[i].protocol.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  /*
    Filters the page list showing only the devices that match the
    ip, mac or protocol the user has typed in the form
  */
  handleSubmit = () => {
    if (this.state.formInput !== "" && ipRegex.test(this.state.formInput)) {
      this.handleIPSearch();
    }
    else if (this.state.formInput !== "" && macRegex.test(this.state.formInput)) {
      this.handleMacAddressSearch();
    }
    else if (this.state.formInput !== "" && nameRegex.test(this.state.formInput)) {
      this.handleProtocolSearch();
    }
    else if (this.state.formInput === "") {
      this.setState({ devices: this.state.originalDevices });
    }
  }

  retrieveData = async () => {
    // Retrieve devices list only if the input form is empty and the user
    // didn't sort the table by clicking a column header
    if (this.state.formInput === "" && !this.state.isColumnClicked) {

      let promissesArray = [];

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "tcpIpInterface", { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "pingLimitConfig", { mode: "cors" })
          .then(res => res.json())
          .then(data => data.pingLimit)
      );

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "networkAvailability", { mode: "cors" })
          .then(res => res.json())
          .then(data => data.percentageAvailable)
      );

      let resolvedPromisses = await Promise.all(promissesArray);

      let liveList = resolvedPromisses[0].sort((a, b) => {
        const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        return num1 - num2;
      });

      let tcpIpInterface = resolvedPromisses[1].sort((a, b) => {
        const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
        return num1 - num2;
      });

      let pingLimit = resolvedPromisses[2];

      let networkAvailability = resolvedPromisses[3].toFixed(0).concat("%");

      // Add the config_method if the device's protocol is Ethernet/IP
      for (let i = 0; i < liveList.length; i++) {
        if (liveList[i].protocol === Strings.ETHERNET_IP) {
          for (let j = 0; j < tcpIpInterface.length; j++) {
            if (liveList[i].mac === tcpIpInterface[j].id) {
              liveList[i].config_method = tcpIpInterface[j].config_method;
              break;
            }
          }
        }
        else {
          liveList[i].config_method = "";
        }

        if (liveList[i].status === Constants.FAULT) {
          liveList[i].severity = 3;
        }
        else if (liveList[i].status === Constants.OK) {
          liveList[i].severity = 0;
        }
        else if (liveList[i].status === Constants.ONLINE) {
          liveList[i].severity = 1;
        }
        else if (liveList[i].status === Constants.OFFLINE) {
          liveList[i].severity = 2;
        }
      }

      this.setState({
        devices: liveList,
        originalDevices: liveList,
        pingLimit: pingLimit,
        networkAvailability: networkAvailability
      });
    }
  }

  createIpCell = (device) => {
    if (device.isDuplicated) {
      return <Table.Cell
        style={duplicatedCellStyle}
        verticalAlign="middle"
        onClick={this.handleDuplicatedIPClick(device.ip, device.mac)}>
        {device.ip}
      </Table.Cell>;
    }
    else {
      if (device.ip === "0.0.0.0") {
        return <Table.Cell
          style={zeroIpStyle}
          verticalAlign="middle"
          onClick={this.handleZeroIPClick(device.ip, device.mac)}>
          {device.ip}
        </Table.Cell>;
      }
      else {
        return <Table.Cell verticalAlign="middle">{device.ip}</Table.Cell>;
      }
    }
  }

  createConfigMethodCell = (configMethod) => {
    if (configMethod.includes("2")) {
      return (
        <Table.Cell
          style={dhcpCellStyle}
          verticalAlign="middle">
          {configMethod}
        </Table.Cell>
      );

    }
    else {
      return (
        <Table.Cell
          verticalAlign="middle">
          {configMethod}
        </Table.Cell>
      );
    }
  }

  createPingCell = (pingCurrent, pingAvg) => {
    let pingCurrentText = pingCurrent === "-" ? pingCurrent : `${pingCurrent}${Strings.MILLISECONDS_SUFFIX}`;
    let pingAvgText = pingAvg === "-" ? pingAvg : `${pingAvg}${Strings.MILLISECONDS_SUFFIX}`;

    return (
      <Table.Cell verticalAlign="middle">
        {pingCurrentText} / {pingAvgText}
      </Table.Cell>
    );

  }

  createStatusCell = (device) => {
    if (device.status === Constants.OK) {
      return (
        <Table.Cell style={okCellStyle}>
          {Strings.OK_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.FAULT) {
      return (
        <Table.Cell style={faultCellStyle}>
          {Strings.FAULT_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.ONLINE) {
      return (
        <Table.Cell style={onlineCellStyle}>
          {Strings.ONLINE_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.OFFLINE) {
      return (
        <Table.Cell style={offlineCellStyle}>
          {Strings.OFFLINE_STRING}
        </Table.Cell>
      );
    }
  }

  /*
    Adjusts the size of the table so that it does not excced the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_LIVE_TOPOLOGY;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  exportLiveListAsCSV = () => {
    let csvText = Strings.LIVE_LIST_CSV_HEADER;

    for (let i = 0; i < this.state.originalDevices.length; i++) {
      let pingAvg = this.state.originalDevices[i].pingAvg === "-" ? "-" : this.state.originalDevices[i].pingAvg;
      let pingCurrent = this.state.originalDevices[i].pingCurrent === "-" ? "-" : this.state.originalDevices[i].pingCurrent;

      csvText += this.state.originalDevices[i].ip + ","
        + this.state.originalDevices[i].mac + ","
        + this.state.originalDevices[i].protocol + ","
        + this.state.originalDevices[i].config_method + ","
        + pingCurrent + ","
        + pingAvg + ","
        + this.state.originalDevices[i].lostPings + ","
        + this.state.originalDevices[i].lostPingsPercentage.toFixed(2) + "%,"
        + this.state.originalDevices[i].percentageAvailable.toFixed(2) + "%,"
        + this.getStatusTextForCSV(this.state.originalDevices[i]) + "\n";
    }

    const workbook = read(csvText, { type: "string", raw: true });
    /* Aqui convertemos o workbook para o formato .xlsx */
    const wbout = write(workbook, { bookType: "xlsx", type: "binary" });

    /* Criação do blob e link para download */
    const blob = new Blob([UtilsInstance.s2ab(wbout)], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = Strings.LIVE_LIST_CSV_EXPORT_NAME;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  getStatusTextForCSV = (device) => {
    if (device.status === Constants.OK) {
      return Strings.OK_STRING;
    }
    else if (device.status === Constants.OFFLINE) {
      return Strings.OFFLINE_STRING;
    }
    else if (device.status === Constants.ONLINE) {
      return Strings.ONLINE_STRING;
    }
    else if (device.status === Constants.FAULT) {
      return Strings.FAULT_STRING;
    }
  }

  // ------------------- Timeline event -------------------
  getTimelineData = (device) => {
    // Espera ter pelo menos 8 elementos na lista antes de construir a timeline
    if (device.tendency !== undefined && device.tendency !== null && device.tendency.length > 8) {
      let finalTendency = [];

      if (device.tendency.length > 0 && device.tendency.length <= 72) {
        // De 8 em 8 elementos
        for (let i = 0; i < device.tendency.length; i = i + 8) {
          finalTendency.push(Math.max(...device.tendency.slice(i, i + 8)));
        }
      } else if (device.tendency.length > 72 && device.tendency.length <= 144) {
        // De 16 em 16 elementos
        for (let i = 0; i < device.tendency.length; i = i + 16) {
          finalTendency.push(Math.max(...device.tendency.slice(i, i + 16)));
        }
      } else if (device.tendency.length > 144 && device.tendency.length <= 216) {
        // De 24 em 24 elementos
        for (let i = 0; i < device.tendency.length; i = i + 24) {
          finalTendency.push(Math.max(...device.tendency.slice(i, i + 24)));
        }
      } else if (device.tendency.length > 216 && device.tendency.length <= 288) {
        // De 32 em 32 elementos
        for (let i = 0; i < device.tendency.length; i = i + 32) {
          finalTendency.push(Math.max(...device.tendency.slice(i, i + 32)));
        }
      } else if (device.tendency.length > 288 && device.tendency.length <= 360) {
        // De 40 em 40 elementos
        for (let i = 0; i < device.tendency.length; i = i + 40) {
          finalTendency.push(Math.max(...device.tendency.slice(i, i + 40)));
        }
      } else if (device.tendency.length > 360 && device.tendency.length <= 432) {
        // De 48 em 48 elementos
        for (let i = 0; i < device.tendency.length; i = i + 48) {
          finalTendency.push(Math.max(...device.tendency.slice(i, i + 48)));
        }
      } else if (device.tendency.length > 432 && device.tendency.length <= 504) {
        // De 56 em 56 elementos
        for (let i = 0; i < device.tendency.length; i = i + 56) {
          finalTendency.push(Math.max(...device.tendency.slice(i, i + 56)));
        }
      } else if (device.tendency.length > 504 && device.tendency.length <= 576) {
        // De 64 em 64 elementos
        for (let i = 0; i < device.tendency.length; i = i + 64) {
          finalTendency.push(Math.max(...device.tendency.slice(i, i + 64)));
        }
      } else if (device.tendency.length > 576 && device.tendency.length <= 648) {
        // De 72 em 72 elementos
        for (let i = 0; i < device.tendency.length; i = i + 72) {
          finalTendency.push(Math.max(...device.tendency.slice(i, i + 72)));
        }
      } else if (device.tendency.length > 648 && device.tendency.length <= 720) {
        // De 80 em 80 elementos
        for (let i = 0; i < device.tendency.length; i = i + 80) {
          finalTendency.push(Math.max(...device.tendency.slice(i, i + 80)));
        }
      }

      // To build our timeline we start by getting the time in milliseconds when the function was called
      let currentTimeInMillis = new Date().getTime();
      let timelineArray = [];

      // Then we build the timeline adding the pings from the newest to the oldest
      // The last ping in 'tendency' is the newest one, we start from it and keep
      // adding the older ones (the interval between events is 5 seconds, that is why
      // we subtract 5000 milis for every event added)
      for (let i = (finalTendency.length - 1); i >= 0; i--) {
        // insert always at the beginning, so the events will be in chronological order
        // the first event will be the oldest and the last event will be the newest 
        timelineArray.unshift({
          startTime: new Date(currentTimeInMillis - 5000),
          endTime: new Date(currentTimeInMillis),
          type: finalTendency[i]
        });

        currentTimeInMillis = currentTimeInMillis - 5000;
      }

      // Now prepare the data to be in the format the Chart needs
      const events = timelineArray.map(
        ({ startTime, endTime, ...data }) =>
          new TimeRangeEvent(new TimeRange(new Date(startTime), new Date(endTime)), data)
      );

      let series = new TimeSeries({ name: "timeline", events });
      let seriesTimerange = series.timerange();

      return (
        <Resizable style={resizableStyle}>
          <ChartContainer
            timeAxisTickCount={5}
            timeRange={seriesTimerange}
            timeAxisHeight={0}>
            <ChartRow
              height="30">
              <Charts>
                <EventChart
                  onSelectionChange={() => { this.handleCellClick(device); }}
                  series={series}
                  spacing={-0.5}
                  style={this.styleTimelineEvent}
                />
              </Charts>
            </ChartRow>
          </ChartContainer>
        </Resizable>
      );
    }
    else {
      return Strings.INSUFFICIENT_DATA;
    }
  }

  styleTimelineEvent = (event, state) => {
    const color = this.getTimelineEventColor(event.get("type"));

    switch (state) {
      case "normal":
        return {
          fill: color
        };
      case "hover":
        return {
          fill: color,
          opacity: 0.4
        };
      case "selected":
        return {
          fill: color
        };
      default:
      // Do nothing
    }
  }

  getTimelineEventColor = (ping) => {
    if (ping < 16) {
      return Constants.OK_CHART_COLOR;
    } else if (ping >= 16 && ping < 26) {
      return Constants.DIAGNOSTIC_CHART_COLOR;
    } else {
      return Constants.FAULT_CHART_COLOR;
    }
  }

  handleCellClick = (device) => {
    if (device.tendency !== undefined && device.tendency !== null && device.tendency.length > 8) {
      this.props.onChangePingGraph();
      this.props.history.push({
        pathname: "/pingGraph",
        state: { deviceIP: device.ip }
      });
    }
  }

  handleDuplicatedIPClick = (ip, mac) => () => {
    this.setState({
      clickedDevice: ip,
      clickedMac: mac,
      showModal: true,
      askDeleteText: Strings.ASK_DELETE_OR_LOG_1,
    });
  }

  handleZeroIPClick = (ip, mac) => () => {
    this.setState({
      clickedDevice: ip,
      clickedMac: mac,
      showModal: true,
      askDeleteText: Strings.ASK_DELETE_OR_LOG_2,
    });
  }

  removeOfflineOrDuplicateDevice = (deviceMacAddress) => {
    let data = JSON.stringify({
      mac: deviceMacAddress
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "remove_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.REMOVE_DEVICE_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.REMOVE_DEVICE_FAILURE + "\n" + Strings.REASON_DP + error);
      });
  }

  handleModalDeleteClick = () => {
    this.setState({ showModal: false }, () => {
      this.removeOfflineOrDuplicateDevice(this.state.clickedMac);
    });
  }

  closeModal = () => this.setState({ showModal: false })

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  componentDidUpdate() {
    this.adjustTableMaxHeight();
  }

  // Render the table containing all network devices
  render() {
    const column = this.state.column;
    const direction = this.state.sortDirection;
    const filter = this.state.formInput;

    const devices = this.state.devices.map(device => (
      <Table.Row key={device.mac}>
        {this.createIpCell(device)}
        <Table.Cell verticalAlign="middle">{device.mac}</Table.Cell>
        <Table.Cell verticalAlign="middle">{device.protocol}</Table.Cell>
        {this.createConfigMethodCell(device.config_method)}
        {this.createPingCell(device.pingCurrent, device.pingAvg)}
        <Table.Cell verticalAlign="middle">{device.lostPings} / {device.lostPingsPercentage.toFixed(2)}%</Table.Cell>
        <Table.Cell>{device.percentageAvailable.toFixed(2)} %</Table.Cell>
        <Table.Cell
          verticalAlign="middle"
          onClick={() => { this.handleCellClick(device); }}>
          {this.getTimelineData(device)}
        </Table.Cell>
        {this.createStatusCell(device)}
      </Table.Row >
    ));

    return (
      <div style={screenStyle}>

        <Grid columns="equal" textAlign="center" verticalAlign="middle">
          <Grid.Row>
            <Grid.Column>
              <p><b>{Strings.NETWORK_AVAILABILITY_DP}</b>{this.state.networkAvailability}</p>
            </Grid.Column>

            <Grid.Column>
              <Form style={searchStyle} onSubmit={this.handleSubmit} >
                <Form.Input
                  id="inputform"
                  placeholder={Strings.LIVE_LIST_INPUT_TEXT_PLACEHOLDER}
                  icon="search"
                  name="formInput"
                  value={filter}
                  onChange={this.handleChange} />
              </Form>
            </Grid.Column>

            <Grid.Column>
              <Segment id="legend-segment" basic textAlign="right">

                <Button
                  content={Strings.EXPORT_CSV}
                  color="teal"
                  onClick={this.exportLiveListAsCSV} />

              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Table id="table-header" style={headerMarginStyle} sortable striped celled fixed singleLine selectable textAlign="center">
          <Table.Header>
            <Table.Row>

              <Popup position='bottom left' hoverable pinned
                trigger={
                  <Table.HeaderCell
                    sorted={column === "ip" ? direction : null}
                    onClick={this.handleSort("ip")}>
                    {Strings.IP}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.IP_POPUP_1}</p>
                  <div><Image centered src={process.env.PUBLIC_URL + "/images/exemplo-ip-duplicado.png"} /></div>
                  <p style={{ marginTop: "1vh" }}>{Strings.IP_POPUP_2}</p>
                  <Image centered src={process.env.PUBLIC_URL + "/images/exemplo-perda-ip.png"} />
                  <p style={{ marginTop: "1vh" }}>{Strings.IP_POPUP_3}</p>
                </Popup.Content>
              </Popup>

              <Table.HeaderCell
                sorted={column === "mac" ? direction : null}
                onClick={this.handleSort("mac")}>
                {Strings.MAC}
              </Table.HeaderCell>

              <Table.HeaderCell
                sorted={column === "protocol" ? direction : null}
                onClick={this.handleSort("protocol")}>
                {Strings.PROTOCOL}
              </Table.HeaderCell>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    sorted={column === "config_method" ? direction : null}
                    onClick={this.handleSort("config_method")}>
                    {Strings.CONFIG_METHOD_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                    <br />
                    {Strings.CONFIG_METHOD_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.CONFIG_METHOD_POPUP_1}</p>
                  <p>{Strings.CONFIG_METHOD_POPUP_2}</p>
                  <p>{Strings.CONFIG_METHOD_POPUP_3}</p>
                  <p>{Strings.CONFIG_METHOD_POPUP_4}</p>
                  <p>{Strings.CONFIG_METHOD_POPUP_5}</p>
                  <p>{Strings.CONFIG_METHOD_POPUP_6}</p>
                  <Image centered src={process.env.PUBLIC_URL + "/images/exemplo-dhcp.png"} />
                </Popup.Content>
              </Popup>

              <Table.HeaderCell disabled>
                {Strings.CURRENT_PING} /
                <br />
                {Strings.MEDIUM_PING}
              </Table.HeaderCell>

              <Popup position='bottom center' hoverable pinned wide
                trigger={
                  <Table.HeaderCell
                    sorted={column === "lostPingsPercentage" ? direction : null}
                    onClick={this.handleSort("lostPingsPercentage")}>
                    {Strings.LOST_PACKET_PERC_1}
                    <Icon name="question circle" color="teal" style={questionIconStyle} /> <br />
                    {Strings.LOST_PACKET_PERC_2}
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.MISSED_PINGS_POPUP}</p>
                </Popup.Content>
              </Popup>

              <Table.HeaderCell
                sorted={column === "percentageAvailable" ? direction : null}
                onClick={this.handleSort("percentageAvailable")}>
                {Strings.AVAILABILITY}
              </Table.HeaderCell>

              <Popup position='bottom right' hoverable pinned wide="very"
                trigger={
                  <Table.HeaderCell disabled>
                    {Strings.TENDENCY}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.TENDENCY_POPUP_1}</p>
                  <p><strong>{Strings.OBS}</strong>{Strings.TENDENCY_POPUP_2}</p>
                  {Strings.TENDENCY_POPUP_3}<strong>{Strings.TENDENCY_GOOD_PING_LIMIT}</strong>{Strings.TENDENCY_POPUP_4}
                  <Image centered src={process.env.PUBLIC_URL + "/images/tendencia-verde.png"} />
                  {Strings.TENDENCY_POPUP_5}<strong>{Strings.TENDENCY_WARNING_PING_LIMIT}</strong>{Strings.TENDENCY_AND}<strong>{Strings.TENDENCY_WARNING_UPPER_PING_LIMIT}</strong>{Strings.TENDENCY_POPUP_6}
                  <Image centered src={process.env.PUBLIC_URL + "/images/tendencia-amarela.png"} />
                  {Strings.TENDENCY_POPUP_7}<strong>{Strings.TENDENCY_BAD_PING_LIMIT}</strong>{Strings.TENDENCY_POPUP_8}
                  <Image centered src={process.env.PUBLIC_URL + "/images/tendencia-vermelha.png"} />
                </Popup.Content>
              </Popup>

              <Popup position='bottom right' hoverable pinned wide="very"
                trigger={
                  <Table.HeaderCell
                    sorted={column === "severity" ? direction : null}
                    onClick={this.handleSort("severity")}>
                    {Strings.STATUS}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <div style={popupContainerStyle}>
                    <Image src={process.env.PUBLIC_URL + "/images/ok.png"} style={popupStatusImageStyle} />
                    <p>{Strings.LIVE_LIST_OK_POPUP_TEXT}</p>
                  </div>
                  <Divider style={popupDividerStyle} />
                  <div style={popupContainerStyle}>
                    <Image src={process.env.PUBLIC_URL + "/images/fault.png"} style={popupStatusImageStyle} />
                    <p>{Strings.LIVE_LIST_FAULT_POPUP_TEXT}</p>
                  </div>
                  <Divider style={popupDividerStyle} />
                  <div style={popupContainerStyle}>
                    <Image src={process.env.PUBLIC_URL + "/images/online.png"} style={popupStatusImageStyle} />
                    <p>{Strings.LIVE_LIST_ONLINE_POPUP_TEXT}</p>
                  </div>
                  <Divider style={popupDividerStyle} />
                  <div style={popupContainerStyle}>
                    <Image src={process.env.PUBLIC_URL + "/images/offline.png"} style={popupStatusImageStyle} />
                    <p>{Strings.LIVE_LIST_OFFLINE_POPUP_TEXT}</p>
                  </div>
                </Popup.Content>
              </Popup>

            </Table.Row>
          </Table.Header>
        </Table>

        <div id="main-table-container" style={tableStyle}>
          <Table id="main-table" sortable striped celled fixed selectable textAlign="center">
            <Table.Body>{devices}</Table.Body>
          </Table>
        </div>

        <Modal style={modalStyle} centered open={this.state.showModal} onClose={this.closeModal} size='small'>
          <Header icon='trash' content={Strings.GO_TO_LOG_OR_REMOVE_POSITIONING} />
          <Modal.Content>
            <p> {this.state.askDeleteText} </p>
            <p> <b>{Strings.IP}:</b> {this.state.clickedDevice} </p>
            <p> <b>{Strings.MAC}:</b> {this.state.clickedMac.toUpperCase()} </p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color='red'
              onClick={() => { this.closeModal(); }}>
              <Icon name='times' />{Strings.NO}
            </Button>
            <Button
              color='green'
              onClick={this.handleModalDeleteClick}>
              <Icon name='checkmark' />{Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

      </div >
    );
  }

}

// CSS custom table stylization
const screenStyle = {
  margin: "2vh 2vw",
  textAlign: "center",
};

const tableStyle = {
  overflowY: "scroll"
};

const headerMarginStyle = {
  marginTop: "0px",
  marginBottom: "8px",
  width: "99.5%"
};

const searchStyle = {
  margin: "0 auto",
  marginTop: "8px",
  marginBottom: "16px"
};

const zeroIpStyle = {
  backgroundColor: "orange"
};

const mapActionsToProps = {
  onChangePingGraph: pingGraphAction
};

const resizableStyle = {
  // marginTop: "0px",
  marginBottom: "-18px"
};

const questionIconStyle = {
  marginLeft: "4px"
};

const dhcpCellStyle = {
  color: "white",
  backgroundColor: "#191970",
  verticalAlign: "middle"
};

const duplicatedCellStyle = {
  color: "white",
  backgroundColor: "purple",
  verticalAlign: "middle"
};

const okCellStyle = {
  color: "black",
  backgroundColor: "lime",
  verticalAlign: "middle"
};

const faultCellStyle = {
  color: "black",
  backgroundColor: "red",
  verticalAlign: "middle"
};

const offlineCellStyle = {
  color: "black",
  backgroundColor: "lightGrey",
  verticalAlign: "middle"
};

const onlineCellStyle = {
  color: "black",
  backgroundColor: "lightBlue",
  verticalAlign: "middle"
};

const popupContainerStyle = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
};

const popupStatusImageStyle = {
  height: "18px",
  width: "100px",
  marginRight: "8px"
};

const popupDividerStyle = {
  marginTop: "4px",
  marginBottom: "4px",
  color: "rgba(64, 64, 64, 0.5)"
};

const modalStyle = {
  width: "800px",
  height: "255px",
  margin: "20vh auto"
};

export default connect(null, mapActionsToProps)(withRouter(LiveList));
